<template>
  <el-dialog title="添加尾款凭证" :visible.sync="formVisible" :close-on-click-modal="false" width="800px" v-if="formVisible"> 
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="120px">
      <el-form-item label="客户：" prop="customerId" class="width100">
        <el-select v-model="form.customerId" :placeholder="请选择" clearable filterable :filter-method="customerFilter">
          <el-option :label="`${item.name} (${item.pho})(${item.levelName})${item.cityCompanyName || ''}`" :value="item.id" v-for="item in clientOption" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="付款凭证：" prop="payVoucherUrl" class="width100 is-required">
        <div class="upload-box flexs">
          <div class="upload-img">
            <el-upload :action="uploadUrl" list-type="picture-card" :multiple="false" limit="3" :on-success="handleSuccess" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <div class="upload-input">
            <div class="item" v-for="(item,index) in form.registrationPayList" :key="index">
              <el-button type="primary" @click="getOcrTest(index)" v-if="!item.ocrContent" style="width: 120px;">通过OCR提取文字</el-button>
              <el-popover v-else placement="top-start" title="" width="400" trigger="hover" :content="item.ocrContent">
                <el-button slot="reference">查看OCR提取的信息</el-button>
              </el-popover>
              <div style="display: flex;align-items: center;">
                <el-form-item :prop="'registrationPayList.' + index + '.payBank'" :rules="{ required: true, message: '请选择收款银行', trigger: 'change' }" class="cus-sty">
                  <el-select v-model="item.payBank" placeholder="请选择收款银行" filterable>
                    <el-option :label="it.bankName" :value="it.bankName" v-for="(it,idx) in enabledSectionList" :key="idx"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :prop="'registrationPayList.' + index + '.payNum'" :rules="{ required: true, message: '请输入支付单号', trigger: 'blur' }" class="cus-sty">
                  <el-input v-model="item.payNum" placeholder="请输入支付单号"></el-input>
                </el-form-item>
              </div>
              <div style="display: flex;align-items: center;">
                <el-form-item :prop="'registrationPayList.' + index + '.payMoney'" :rules="{ required: true, message: '请输入付款金额', trigger: 'blur' }" class="cus-sty">
                  <el-input v-model="item.payMoney" placeholder="请输入付款金额"></el-input>
                </el-form-item>
                <el-form-item :prop="'registrationPayList.' + index + '.payTime'" :rules="{ required: true, message: '请选择付款日期', trigger: 'change' }" class="cus-sty">
                  <el-date-picker v-model="item.payTime" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="付款日期"></el-date-picker>
                </el-form-item>
              </div>
              <!-- <el-input v-model="item.payNum" placeholder="请输入支付单号"></el-input> -->
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="附件：" prop="applyVoucher" class="width100">
        <div class="flexs">
          <el-upload :action="uploadUrl" list-type="picture-card" :file-list="applyVoucher" :on-success="handleImgUpload1" :on-remove="handleRemove1">
            <i class="el-icon-plus"></i>
          </el-upload>
          <span class="hint">支持上传多张</span>
        </div>
      </el-form-item>
      <el-form-item label="充值赠送金额" prop="upgradeGiftAmount" class="width100">
        <el-input v-model="form.upgradeGiftAmount" placeholder="请输入充值赠送金额"></el-input>
      </el-form-item>
      <!-- <el-form-item label="账户入账凭证" prop="lineUpBankType" class="width100">
        <el-select v-model="form.lineUpBankType" placeholder="请选择推送学费账户入账凭证" filterable>
          <el-option :label="item.configName" :value="item.configKey" v-for="(item,index) in reasonOptions" :key="index"></el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import rechargeRecordApi from '@/api/recharge/rechargeRecord'
import customerRegistrationApi from '@/api/cust/customerRegistration'
import ImageUpload from "@/components/ImageUpload";
import managecustomerwalletApi from '@/api/cust/managecustomerwallet'
import sysGiftAccountReasonApi from '@/api/config/sysGiftAccountReason'
import { debounce } from 'lodash'
function initFormBean() {
  const formBean = {
    customerId: '',
    lineUpBankType: '',
    upgradeGiftAmount: null,
    applyVoucher: null,
    registrationPayList: [],
    payVoucherUrl: []
  }
  return formBean
}

export default {
  components: {
    ImageUpload
  },
  //popType 0:新增 1:编辑 2:修改身份
  props: {
    sectionList: Array,
    popType: Number
  },
  data() {
    return {

      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      isLoading: false,
      formRules: {
        customerId: [{ required: true, message: '请选择客户', trigger: 'change' }],
        upgradeGiftAmount: [{ required: true, message: '请输入充值赠送金额', trigger: 'blur' }],
        // lineUpBankType: [{ required: true, message: '请选择推送学费账户入账凭证', trigger: 'change' }],
        payVoucherUrl: [{ required: true, message: '请上传付款凭证', trigger: 'blur' }],
      },
      uploadImgs: [],
      id: '',
      applyVoucher: [],
      reasonOptions: [] // 原因选项列表
    }
  },
  computed: {
    // 仅显示已启用的银行
    enabledSectionList() {
      return (this.sectionList || []).filter(it => String(it.isEnable) === '1')
    }
  },
  created() {
    this.debouncedGetOption = debounce(this.getOption, 500)
    // 添加初始调用
    this.getOption('')
    this.getReasonOption()
  },
  methods: {
    customerFilter(e) {
      this.debouncedGetOption(e)
    },
    async getOption(e) {
      this.form.customerId = null
      let obj = { pageNo: 1, pageSize: 100, name: e }
      const { data } = await managecustomerwalletApi.findAreaCustomerList(obj)
      this.clientOption = data;
      this.$forceUpdate()
    },
    handleImgUpload1(response, file, fileList) {
      if (file && file.response) {
        this.applyVoucher.push({
          url: file.response.data
        })
      }
    },
    handleRemove1(file, fileList) {
      // console.log('22',file, fileList);
      this.applyVoucher = fileList
    },
    /**
     * 识别支付单号
     */
    getOcrTest(index) {
      console.log('this.form.registrationPayList[index].payImg: ', this.form.registrationPayList, index);
      return rechargeRecordApi.accurateOCR({ imageUrl: this.form.registrationPayList[index].payImg })
        .then(res => {
          this.form.registrationPayList[index].ocrContent = res.data
          this.$forceUpdate()
        })
    },
    handleSuccess(response, file, fileList) {
      console.log('file: ', file);
      this.uploadImgs.push(file.response.data)
      this.form.payVoucherUrl = this.uploadImgs.join(',')
      let obj = {
        ocrContent: '',
        payNum: '',
        payBank: '',
        payMoney: '',
        payTime: '',
        payImg: file.response.data,
        dataType: 0,
        state: 1
      }
      this.form.registrationPayList.push(obj)
    },
    handleRemove(file, fileList) {
      let index = this.uploadImgs.findIndex(item => item == file.response.data)
      this.uploadImgs.splice(index, 1)
      this.registrationPayList.splice(index, 1)
    },
    resetForm() {
      this.form = initFormBean()
      this.uploadImgs = []
    },
    /**
     * 获取原因选项列表
     */
    getReasonOption() {
      sysGiftAccountReasonApi.findOption().then(({ data }) => {
        if (data) {
          this.reasonOptions = data
        }
      })
    },
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      // 查找默认原因（学费赠送入账）
      let findReason = this.reasonOptions.find(i => i.configName == '学费赠送入账')
      if (findReason) {
        this.form.lineUpBankType = findReason.configKey
      }
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let query = JSON.parse(JSON.stringify(this.form))
          query.upgradeGiftAmount = +query.upgradeGiftAmount
          query.applyVoucher = this.applyVoucher.map(item => item.url).toString()
          query.lineUpBankType = query.registrationPayList.map(item => item.payBank).toString()
          delete query.payVoucherUrl
          customerRegistrationApi.addPayWK(query).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isLoading = false
          });
        }
      });
    },
    postCallback(data) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
  }
}
</script>
<style lang="scss" scoped>
.cus-sty {
  width: 220px;
  margin-bottom: 2px;
  margin-right: 2px;
}
.tip-box {
  margin-bottom: 20px;

  i {
    font-size: 24px;
    margin-right: 10px;
    color: #e6a23c;
  }
}
.upload-box {
  align-items: flex-start;
  .upload-img {
    width: 80px;
    margin-right: 10px;
  }
  .upload-input {
    width: calc(100% - 80px);
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 70px;
      margin-bottom: 10px;
    }
  }
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-upload-list__item,
::v-deep .el-upload--picture-card {
  width: 70px;
  height: 70px;
  line-height: 75px;
  margin-bottom: 35px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
</style>
